import _ from 'lodash'
import request from '@/utils/request'
import router from '../router/index'

export function getMp() {
  return _.get(router, ['history', 'current', 'query', 'mp'])
}

// 查询
export function fetchPosterDetail(params) {
  if (getMp() === 'taofeng' || getMp() === 'jinduo_new') {
    return request({
      url: `/api/waiters/poster/details/${params.id}`,
      method: 'get',
      params
    })
  }

  return request({
    url: `/server/posters/getDetail`,
    method: 'get',
    params
  })
}

// 添加
export function addUserPoster(data) {
  if (getMp() === 'taofeng' || getMp() === 'jinduo_new') {
    return request({
      url: `/api/waiters/poster/userPoster`,
      method: 'post',
      data
    })
  }

  return request({
    url: `/server/user_buy_posters/add`,
    method: 'post',
    data
  })
}
